import makeStyles from '@mui/styles/makeStyles';
import colors from '../../styles/colors';

export const useStyles = makeStyles(() => ({
  clearFilters: {
    width: '170px',
    marginLeft: '12px',
    marginBottom: '4px',
    marginTop: '4px',
    whiteSpace: 'nowrap',
    '&:hover': {
      cursor: 'pointer',
      textDecoration: 'underline',
    },
  },
  deleteIcon: {
    minWidth: '16px',
    width: '16px',
    height: '16px',
  },
  showMoreOrLess: {
    display: 'inline-flex',
    color: 'black',
    fontWeight: 600,
    fontSize: '14px',
    letterSpacing: '0.25px',
    borderBottom: '1px solid black',
    marginLeft: '12px',
    '&:hover': {
      cursor: 'pointer',
    },
    '& span': {
      marginBottom: '-2px',
      paddingTop: '4px',
    },
  },
  showMoreOrLessIcon: {
    position: 'relative',
    left: '1px',
    top: '4px',
    width: '18px',
    height: '18px',
    marginLeft: '-2px',
    marginRight: '4px',
    color: colors.black,
  },
}));
